let TOOLTIP_DOCUMENT_DESCRIPTION = "TOOLTIP_DOCUMENT_DESCRIPTION";
let FIELD_DPK_DOCS_FILE_TYPE = "FIELD_DPK_DOCS_FILE_TYPE";
let TOOLTIP_DOCUMENT_FILE_NAME = "TOOLTIP_DOCUMENT_FILE_NAME";
let FIELD_DHLOSH_SIMPLE_HM_ORIST = "FIELD_DHLOSH_SIMPLE_HM_ORIST";
let FIELD_DHLOSH_SIMPLE_HM_DHM = "FIELD_DHLOSH_SIMPLE_HM_DHM";
let FIELD_DHLOSH_SIMPLE_AR_PROT = "FIELD_DHLOSH_SIMPLE_AR_PROT";
let FIELD_DHLOSH_SIMPLE_ETOS = "FIELD_DHLOSH_SIMPLE_ETOS";
let LABEL_LOGIN_GLOBAL_MESSAGE_APP = "LABEL_LOGIN_GLOBAL_MESSAGE_APP";
let LABEL_LOGIN_TITLE = "LABEL_LOGIN_TITLE";
let VALIDATION_EMAIL_INVALID = "VALIDATION_EMAIL_INVALID";
let VALIDATION_NAMES_INVALID = "VALIDATION_NAMES_INVALID";
let LABEL_LOGIN_ERROR = "LABEL_LOGIN_ERROR";
let WARNING_LABEL_DPK_IDIOTHTES_SEARCH = "WARNING_LABEL_DPK_IDIOTHTES_SEARCH";
let WARNING_LABEL_FINALIZE_CATALOG = "WARNING_LABEL_FINALIZE_CATALOG";
let WARNING_LABEL_MAIN_CATALOG = "WARNING_LABEL_MAIN_CATALOG";
let BUTTON_SELECT = "BUTTON_SELECT";
let BUTTON_SELECT1 = "BUTTON_SELECT1";
let LABEL_BACK = "LABEL_BACK";
let LABEL_DIALOG_LOGOUT = "LABEL_DIALOG_LOGOUT";
let VALIDATION_YEAR_FUTURE_INVALID = "VALIDATION_YEAR_FUTURE_INVALID";
let BUTTON_YES = "BUTTON_YES";
let BUTTON_ΝΟ = "BUTTON_ΝΟ";
let IMPORT_MSG = "IMPORT_MSG";
let OFO_MSG = "OFO_MSG"
let WKI_MSG = "WKI_MSG"
let NCM_MSG = "NCM_MSG"
let NEF_MSG = "NEF_MSG"
let FNEF_MSG = "FNEF_MSG"
let NOFC_MSG = "NOFC_MSG"
let UFF_MSG = "UFF_MSG"
let NIF_MSG = "NIF_MSG"
let NTD_MSG = "NTD_MSG."
let CFF_MSG = "CFF_MSG"
let NVF_MSG = "NVF_MSG"
let KHD_MSG = "KHD_MSG"
let EDE_MSG = "EDE_MSG"

/* Start Error Label */
let BUTTON_NO = "BUTTON_NO";
let LABEL_EMPTY_TABLE = "LABEL_EMPTY_TABLE";
let LABEL_DIALOG_DEACTIVATION_SUCCESS = "LABEL_DIALOG_DEACTIVATION_SUCCESS";
let LABEL_DIALOG_DEACTIVATION_FAILED = "LABEL_DIALOG_DEACTIVATION_FAILED";
let LABEL_DIALOG_DEACTIVATION_RESUME = "LABEL_DIALOG_DEACTIVATION_RESUME";
let ERROR_VALIDATION_YEAR_FUTURE_INVALID = "ERROR_VALIDATION_YEAR_FUTURE_INVALID";
let VALIDATION_AMOUNT_INVALID = "VALIDATION_AMOUNT_INVALID";
let WARNING_AFM_TAXIS_MAX_SEARCH = "WARNING_AFM_TAXIS_MAX_SEARCH";
let WARNING_SYMV_YPOXREOI = "WARNING_SYMV_YPOXREOI";
let TABLE_SYMV_YPOXREOI = "TABLE_SYMV_YPOXREOI";
let TABLE_SYMV_YPOXREOI_GENERAL_BUTTON_NAV = "TABLE_SYMV_YPOXREOI_GENERAL_BUTTON_NAV";
let TABLE_SYMV_YPOXREOI_GENERAL_BUTTON = "TABLE_SYMV_YPOXREOI_GENERAL_BUTTON";
/* End Error Label */

/* Start Field Label */
let FIELD_AFM = "FIELD_AFM";
let FIELD_LAST_NAME = "FIELD_LAST_NAME";
let FIELD_FIRST_NAME = "FIELD_FIRST_NAME";
let FIELD_FATHERS_NAME = "FIELD_FATHERS_NAME";
let FIELD_EMAIL = "FIELD_EMAIL";
let FIELD_ODOS = "FIELD_ODOS";
let FIELD_KINHTO = "FIELD_KINHTO";
let FIELD_TK = "FIELD_TK";
let FIELD_PHONE = "FIELD_PHONE";
let FIELD_ARIUMOS = "FIELD_ARIUMOS";
let FIELD_DESCRIPTION = "FIELD_DESCRIPTION";
let FIELD_IS_ACTIVE = "FIELD_IS_ACTIVE";
let FIELD_HMNIA_ORISTIKO = "FIELD_HMNIA_ORISTIKO";
let FIELD_TIMIMA = "FIELD_TIMIMA";
let FIELD_AFM_YPOXREON = "FIELD_AFM_YPOXREON";
let FIELD_FILE_NAME = "FIELD_FILE_NAME";
let FIELD_SYMVOLAIO_EMPR_DIKAIOMA = "FIELD_SYMVOLAIO_EMPR_DIKAIOMA";
let FIELD_HMNIA_SYNTAKSIS = "FIELD_HMNIA_SYNTAKSIS";
let FIELD_AR_SYMVOLAIOU = "FIELD_AR_SYMVOLAIOU";
let FIELD_SYGGENIKI_SXESI = "FIELD_SYGGENIKI_SXESI";
/* End Field Label */

/* Start Button  Label*/
let BUTTON_CONTRACT_BACK = "BUTTON_CONTRACT_BACK";
let BUTTON_CONTRACT_CREATE = "BUTTON_CONTRACT_CREATE";
let LABEL_DPK_DETAILS_TAXIS_BUTTON = "LABEL_DPK_DETAILS_TAXIS_BUTTON";
/* End Button  Label*/

let LABEL_LOGIN_TITLE_SYMVOLAIOGRAFOS_APP = "LABEL_LOGIN_TITLE_SYMVOLAIOGRAFOS_APP";



let FIELD_CODE = "FIELD_CODE";
let FIELD_BANK_NAME = "FIELD_BANK_NAME";
let FIELD_ADRESS = "FIELD_ADRESS";
let FIELD_IS_ONLINE = "FIELD_IS_ONLINE";
let FIELD_EIDOS_DHLOSHS = "FIELD_EIDOS_DHLOSHS";
let FIELD_EXCEPTION_AFM = "FIELD_EXCEPTION_AFM";
let FIELD_FTPS_USERNAME = "FIELD_FTPS_USERNAME";
let FIELD_IS_FTPS_ONLINE = "FIELD_IS_FTPS_ONLINE";
let FIELD_INTEROPERABILITY = "FIELD_INTEROPERABILITY";
let FIELD_ETOS = "FIELD_ETOS";
let FIELD_ETOS_PLACEHOLDER = "FIELD_ETOS_PLACEHOLDER";
let FIELD_MONTH_PLACEHOLDER = "FIELD_MONTH_PLACEHOLDER";
let FIELD_MONTH = "FIELD_MONTH";
let FIELD_FORCE = "FIELD_FORCE";
let FIELD_TYPOS_AITHMATOS = "FIELD_TYPOS_AITHMATOS";
let FIELD_TYPOS_KATALOGOU = "FIELD_TYPOS_KATALOGOU";
let FIELD_ONOMA_ARXEIOU = "FIELD_ONOMA_ARXEIOU";
let FIELD_ANAFORA_KATALOGOU = "FIELD_ANAFORA_KATALOGOU";
let FIELD_HMEROMINIA_EKDOSIS = "FIELD_HMEROMINIA_EKDOSIS";
let FIELD_VERSION = "FIELD_VERSION";
let FIELD_PLITHOS_YPOXREON = "FIELD_PLITHOS_YPOXREON";
let FIELD_APOTELESMATA_PARALAVIS = "FIELD_APOTELESMATA_PARALAVIS";
let FIELD_TYPOS_APOSTOLIS = "FIELD_TYPOS_APOSTOLIS";
let FIELD_SFALMA_ERGASIAS = "FIELD_SFALMA_ERGASIAS";
let FIELD_PROODOS_ERGASIAS = "FIELD_PROODOS_ERGASIAS";
let FIELD_ID = "FIELD_ID";
let FIELD_AFORA = "FIELD_AFORA";
let FIELD_HMEROMINIA_EKKINISIS = "FIELD_HMEROMINIA_EKKINISIS";
let FIELD_HMEROMINIA_OLOKLIROSIS = "FIELD_HMEROMINIA_OLOKLIROSIS";
let FIELD_TYPOS = "FIELD_TYPOS";
let PINAKAS_HO_PI = "PINAKAS_HO_PI";

let FIELD_PARATHRHSEIS = "FIELD_PARATHRHSEIS";
let FIELD_ONOMATEPONYMO1 = "FIELD_ONOMATEPONYMO1";
let FIELD_ONOMATEPONYMO2 = "FIELD_ONOMATEPONYMO2";
let FIELD_EMAIL1 = "FIELD_EMAIL1";
let FIELD_EMAIL2 = "FIELD_EMAIL2";
let FIELD_THLEFONO_1 = "FIELD_THLEFONO_1";
let FIELD_THLEFONO_2 = "FIELD_THLEFONO_2";
let FIELD_EPOPTHS = "FIELD_EPOPTHS";
let FIELD_KATHGORIA = "FIELD_KATHGORIA";
let FIELD_IS_THIGATRIKH = "FIELD_IS_THIGATRIKH";
let FIELD_HM_ENTAKSIS_WS = "FIELD_HM_ENTAKSIS_WS";
let FIELD_HM_ENTAKSIS_FTPS = "FIELD_HM_ENTAKSIS_FTPS";
let FIELD_EKSERESH = "FIELD_EKSERESH";
let FIELD_ACTIONS = "FIELD_ACTIONS";
let FIELD_HM_EKSERESHS = "FIELD_HM_EKSERESHS";
let FIELD_HAS_PUBLIC_KEY = "FIELD_HAS_PUBLIC_KEY";
let FIELD_HM_LHXHS_PUBLIC_KEY = "FIELD_HM_LHXHS_PUBLIC_KEY";

let XOPI_TYPE = "XOPI_TYPE";
let XOPI_TYPE_KEYS = "XOPI_TYPE_KEYS";
let XOPI_TYPE_DATA = "XOPI_TYPE_DATA";
let XOPI_TYPE_ALL = "XOPI_TYPE_ALL";
let XOPI_AFM = "XOPI_AFM";
let XOPI_MSG = "XOPI_MSG";

/* Start Error Caption */

export let captions_el = [];
captions_el[LABEL_LOGIN_GLOBAL_MESSAGE_APP] = "";
captions_el[LABEL_LOGIN_TITLE] = '<h3 style="font-weight: normal;" >Καταχώριση Μηνιαίων Καταστάσεων</h3>';
captions_el[VALIDATION_EMAIL_INVALID] = "Το email δεν είναι έγκυρο.";
captions_el[LABEL_LOGIN_ERROR] = "Σφάλμα,μη έγκυρο αναγνωριστικό ή κωδικός";
captions_el[VALIDATION_NAMES_INVALID] = "Πρέπει να αποτελείται από κεφαλαίους χαρακτήρες μόνο ελληνικούς ή λατινικούς.<br/> Επιτρέπεται η χρήση παύλας (-), κενού και καθέτου (/) για την εισαγωγή δυο τιμών. ";
captions_el[WARNING_LABEL_DPK_IDIOTHTES_SEARCH] = 'Προσοχή, πρέπει να επιλέξετε ιδιότητα η οποία θα έχει την ένδειξη (Τελική Ιδιότητα)'
captions_el[BUTTON_SELECT] = "Οριστικοποίηση";
captions_el[BUTTON_SELECT1] = "Επιλογή";
captions_el[LABEL_BACK] = "Επιστροφή";
captions_el[LABEL_DIALOG_LOGOUT] = "Θέλετε να αποσυνδεθείτε από το σύστημα και να χαθούν οι μη αποθηκευμένες αλλαγές;";
captions_el[VALIDATION_YEAR_FUTURE_INVALID] = "Η ημ/νία πρέπει να είναι ίση ή μικρότερη της σημερινής και μεγαλύτερη από 31/12/1900";
captions_el[BUTTON_YES] = "Ναι";
captions_el[BUTTON_ΝΟ] = "Όχι";
captions_el[IMPORT_MSG] = "Εάν επιλέξετε <b class='text-success'>«Αντικατάσταση»</b>, για τις εγγραφές με τον ίδιον ΑΦΜ στο σύστημα και στο αρχείο, θα φορτωθούν τα δεδομένα από το αρχείο. <br/> <br/> Εάν επιλέξετε <b class='text-info'>«Διατήρηση»</b>, για τις εγγραφές με τον ίδιον ΑΦΜ στο σύστημα και στο αρχείο, θα διατηρηθούν οι εγγραφές ως έχουν στο σύστημα και θα φορτωθούν μόνο οι εγγραφές από το αρχείο με νέες ιδιότητες για τα ΑΦΜ αυτά.<br/> <br/>" +
    "Και στις δύο περιπτώσεις δε θα πειραχτούν οι εγγραφές στο σύστημα που δεν έχουν ίδιο ΑΦΜ με τις εγγραφές του αρχείου φόρτωσης.\n Για την φόρτωση του αρχείου των συζύγων/ΜΣΣ παρακαλώ επιλέξτε <b class='text-info'>«Διατήρηση»</b>";
captions_el[WARNING_LABEL_FINALIZE_CATALOG] = "<b>Προσοχή: </b> Ο κατάλογος δεν έχει οριστικοποιηθεί. Παρακαλώ Οριστικοποιείστε τον κατάλογο, όταν έχετε ολοκληρώσει τις προσθήκες των υπόχρεων.";
captions_el[WARNING_LABEL_MAIN_CATALOG] = "<b>Προσοχή: </b>Επιτρέπεται καταχώρηση ημερομηνίας ανάληψης μόνο εντός του προηγούμενου μήνα του καταλόγου";
captions_el[FIELD_DHLOSH_SIMPLE_HM_ORIST] = "Ημ/νία Οριστικοποίησης";
captions_el[FIELD_DHLOSH_SIMPLE_AR_PROT] = "Αριθμός Δήλωσης";
captions_el[FIELD_DHLOSH_SIMPLE_HM_DHM] = "Ημ/νία Δημιουργίας";
captions_el[FIELD_DHLOSH_SIMPLE_ETOS] = "Έτος";
captions_el[TOOLTIP_DOCUMENT_FILE_NAME] = "Όνομα Αρχείου";
captions_el[FIELD_DPK_DOCS_FILE_TYPE] = "Τύπος Εγγράφου";
captions_el[TOOLTIP_DOCUMENT_DESCRIPTION] = "Περιγραφή";

captions_el[OFO_MSG] = "Η περίοδος υποβολής καταλόγων έχει ολοκληρωθεί.";
captions_el[WKI_MSG] = "Πρέπει να έχει προστεθεί τουλάχιστον μια ιδιότητα.";
captions_el[NCM_MSG] = "Επιτρέπονται τροποποιήσεις μόνο για τους καταλόγους του τρέχοντος μήνα.";
captions_el[NEF_MSG] = "Δεν βρέθηκε κατάλογος.";
captions_el[FNEF_MSG] = "Η ενέργεια δημιουργίας δεν ολοκληρώθηκε. Δεν επιτρέπεται η δημιουργία μελλοντικών καταλόγων.";
captions_el[NOFC_MSG] = "Η ενέργεια δημιουργίας δεν ολοκληρώθηκε, διότι είναι εκτός ορίων του μήνα.";
captions_el[UFF_MSG] = "Το ανέβασμα του αρχείου απέτυχε. Παρακαλώ προσπαθήστε ξανά.";
captions_el[NIF_MSG] = "Δεν υπάρχει κάποιο ανέβασμα αρχείου ενεργό αυτή την στιγμή.";
captions_el[NTD_MSG] = "Δεν υπάρχει κάποιο αρχείο λάθους.";
captions_el[CFF_MSG] = "Ο κατάλογος έχει Οριστικοποιηθεί και δεν μπορούν να προστεθούν νέες εγγραφές.";
captions_el[NVF_MSG] = "Ο Φορέας που επιλέξατε δεν αντιστοιχεί στον Χρήστη.";
captions_el[KHD_MSG] = "Ο κατάλογος δεν μπορεί να τροποποιηθεί γιατί υπάρχουν οριστικοποιημένες δηλώσεις.";
captions_el[EDE_MSG] = "Δεν μπορείς να διαγράψει την εγγραφή καταλόγου, γιατί έχει δημιουργηθεί Δήλωση.";

captions_el[LABEL_EMPTY_TABLE] = "Δεν βρέθηκαν εγγραφές.";
captions_el[LABEL_DIALOG_LOGOUT] = "Θέλετε να αποσυνδεθείτε από το σύστημα και να χαθούν οι μη αποθηκευμένες αλλαγές;";
captions_el[LABEL_DIALOG_DEACTIVATION_SUCCESS] = "Η Ενημέρωση Ολοκληρώθηκε.";
captions_el[LABEL_DIALOG_DEACTIVATION_FAILED] = "Η Ενημέρωση του Συμβολαίου Απέτυχε.";
captions_el[LABEL_DIALOG_DEACTIVATION_RESUME] = "Το Συμβόλαιο είναι ήδη Απενεργοποιημένο.";
captions_el[ERROR_VALIDATION_YEAR_FUTURE_INVALID] = " Η Ημ/νία πρέπει να είναι μικρότερη ή ίση με την Σημερινή.";
captions_el[VALIDATION_AMOUNT_INVALID] = "Πρέπει να είναι αριθμός. <br/>Ο διαχωρισμός χιλιάδων με τελεία (.) και υποδιαστολή με κόμμα (,) π.χ 2.500,23";
captions_el[WARNING_SYMV_YPOXREOI] = "Πρέπει να έχεις προσθέσει τουλάχιστον ένα πρόσωπο συμβολαίου";
captions_el[TABLE_SYMV_YPOXREOI] = "Πρόσωπα Συμβολαίου";
captions_el[TABLE_SYMV_YPOXREOI_GENERAL_BUTTON_NAV] = "Προσθήκη Προσώπου";
captions_el[TABLE_SYMV_YPOXREOI_GENERAL_BUTTON] = "Διαγραφή Προσώπου";
captions_el[WARNING_AFM_TAXIS_MAX_SEARCH] = ' Έχετε φτάσει στο μέγιστο επιτρεπτό αριθμό αναζητήσεων ΑΦΜ. Παρακαλώ προσπαθήστε αργότερα.'

/*  End Error Caption */

captions_el[FIELD_AFM] = "Α.Φ.Μ.";
captions_el[FIELD_LAST_NAME] = "Επώνυμο";
captions_el[FIELD_FIRST_NAME] = "Όνομα";
captions_el[FIELD_FATHERS_NAME] = "Όνομα Πατρός";
captions_el[FIELD_EMAIL] = "Ηλεκτρονικό Ταχυδρομείο (e-mail)";
captions_el[FIELD_PHONE] = "Σταθερό Τηλέφωνο";
captions_el[FIELD_KINHTO] = "Κινητό Τηλέφωνο";
captions_el[FIELD_ODOS] = "Διεύθυνση Κατοικίας (Πόλη,Οδός)";
captions_el[FIELD_ARIUMOS] = "Αριθμός";
captions_el[FIELD_TK] = "Τ.Κ.";
captions_el[FIELD_DESCRIPTION] = "Περιγραφή";
captions_el[FIELD_IS_ACTIVE] = "Ενεργή Εγγραφή";
captions_el[FIELD_HMNIA_ORISTIKO] = "Ημ/νία Οριστικοποίησης";
captions_el[FIELD_TIMIMA] = "Τίμημα (€)";
captions_el[FIELD_AFM_YPOXREON] = "ΑΦΜ Προσώπων Συμβολαίου";
captions_el[FIELD_FILE_NAME] = "Όνομα Αρχείου (pdf)";
captions_el[FIELD_SYMVOLAIO_EMPR_DIKAIOMA] = "Αιτία Κτήσης";
captions_el[FIELD_HMNIA_SYNTAKSIS] = "Ημ/νία Σύνταξης Συμβολαίου";
captions_el[FIELD_AR_SYMVOLAIOU] = "Αρ.Συμβολαίου";
captions_el[FIELD_SYGGENIKI_SXESI] = "Συγγενική Σχέση";

captions_el[BUTTON_CONTRACT_BACK] = "Επιστροφή";
captions_el[BUTTON_CONTRACT_CREATE] = "Δημιουργία";
captions_el[LABEL_DPK_DETAILS_TAXIS_BUTTON] = "Ενημέρωση από TAXIS";
captions_el[LABEL_BACK] = "Επιστροφή";
captions_el[LABEL_LOGIN_TITLE_SYMVOLAIOGRAFOS_APP] = "<h3 style=\"font-weight: normal\" >Χρηματοπιστωτικά Ιδρύματα</h3>";

captions_el[FIELD_BANK_NAME] = "Επωνυμία Φορέα";
captions_el[FIELD_CODE] = "Κωδικός";
captions_el[FIELD_ADRESS] = "Διεύθυνση";
captions_el[FIELD_IS_ONLINE] = "Ένταξη Λειτουργίας Ws";
captions_el[FIELD_EIDOS_DHLOSHS] = "Είδος Δήλωσης";
captions_el[FIELD_EXCEPTION_AFM] = "Εξαιρούμενα Α.Φ.Μ.";
captions_el[FIELD_FTPS_USERNAME] = "Όνομα Χρήστη";
captions_el[FIELD_IS_FTPS_ONLINE] = "Ένταξη Λειτουργίας ftps";
captions_el[PINAKAS_HO_PI] = "Πίνακας Χρηματοπιστωτικών Ιδρυμάτων";

captions_el[FIELD_PARATHRHSEIS] = "Παρατηρήσεις";
captions_el[FIELD_ONOMATEPONYMO1] = "Ονοματεπώνυμο 1";
captions_el[FIELD_ONOMATEPONYMO2] = "Ονοματεπώνυμο 2";
captions_el[FIELD_EMAIL1] = "Email 1";
captions_el[FIELD_EMAIL2] = "Email 2";
captions_el[FIELD_THLEFONO_1] = "Τηλέφωνο Επικοινωνίας 1";
captions_el[FIELD_THLEFONO_2] = "Τηλέφωνο Επικοινωνίας 2";
captions_el[FIELD_EPOPTHS] = "Επόπτης";
captions_el[FIELD_KATHGORIA] = "Κατηγορία";
captions_el[FIELD_IS_THIGATRIKH] = "Θυγατρική";
captions_el[FIELD_HM_ENTAKSIS_WS] = "Ημερομηνία Ένταξης WS";
captions_el[FIELD_HM_ENTAKSIS_FTPS] = "Ημερομηνία Ένταξης FTPS";
captions_el[FIELD_EKSERESH] = "Εξαίρεση";
captions_el[FIELD_ACTIONS] = "Αρχεία Δεδομένων";
captions_el[FIELD_HM_EKSERESHS] = "Ημερομηνία Εξαίρεσης";
captions_el[FIELD_HAS_PUBLIC_KEY] = "Έχει Δημόσιο Κλειδί";
captions_el[FIELD_HM_LHXHS_PUBLIC_KEY] = "Ημερομηνία Λήξης Δημόσιου Κλειδιού";

captions_el[FIELD_INTEROPERABILITY] = "Αρχεία Δεδομένων";
captions_el[FIELD_ETOS] = "Έτος";
captions_el[FIELD_ETOS_PLACEHOLDER] = "YYYY";
captions_el[FIELD_MONTH] = "Μήνας";
captions_el[FIELD_MONTH_PLACEHOLDER] = "MM";
captions_el[FIELD_FORCE] = "Force";
captions_el[FIELD_TYPOS_AITHMATOS] = "Τυπος αιτηματος";
captions_el[FIELD_TYPOS_KATALOGOU] = "Τύπος καταλόγου";
captions_el[FIELD_ONOMA_ARXEIOU] = "Όνομα αρχείου";
captions_el[FIELD_ANAFORA_KATALOGOU] = "Αναφορά καταλόγου";
captions_el[FIELD_HMEROMINIA_EKDOSIS] = "Ημ/νία έκδοσης";
captions_el[FIELD_VERSION] = "Version";
captions_el[FIELD_PLITHOS_YPOXREON] = "Πλήθος υποχρεώσεων";
captions_el[FIELD_APOTELESMATA_PARALAVIS] = "Αποτέλεσμα παράλαβης";
captions_el[FIELD_TYPOS_APOSTOLIS] = "Τύπος αποστολής";
captions_el[FIELD_SFALMA_ERGASIAS] = "Σφάλμα αποτελέσματος εργασίας";
captions_el[FIELD_PROODOS_ERGASIAS] = "Πρόοδος εργασίας";
captions_el[FIELD_ID] = "ID";
captions_el[FIELD_AFORA] = "Αφορά";
captions_el[FIELD_HMEROMINIA_EKKINISIS] = "Ημ/νία εκκίνησης";
captions_el[FIELD_HMEROMINIA_OLOKLIROSIS] = "Ημ/νία ολοκλήρωσης";
captions_el[FIELD_TYPOS] = "Τύπος";
captions_el[XOPI_TYPE] = "Κλήση για"
captions_el[XOPI_TYPE_KEYS] = "Κλειδιά"
captions_el[XOPI_TYPE_DATA] = "Δεδομένα"
captions_el[XOPI_TYPE_ALL] = "Όλα"
captions_el[XOPI_AFM] = "ΑΦΜ"
captions_el[XOPI_MSG] = "Μήνυμα"


